import { render, staticRenderFns } from "./PublicSite.vue?vue&type=template&id=08bbedd6"
import script from "./PublicSite.vue?vue&type=script&lang=js"
export * from "./PublicSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports